import Layout from '@/layout'

const relationManageRouter = {
  path: '/relation-manage',
  component: Layout,
  redirect: '/relation-manage',
  name: 'relation-manage',
  meta: {
    title: 'routeSystem',
    icon: 'user11'
  },
  children: [
    {
      path: 'sys-image-list',
      component: () => import('@/views/relation-manage/image-list/sys-image-list'),
      name: 'Sysimagelist',
      meta: { title: 'routeSysImg', icon: 'icons113', code: 'edm:photo:management' }
    }
  ]
}

export default relationManageRouter
